/**
 * List Schema of BaseFretebas
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {BaseFretebas} from '@/model/resource/BaseFretebas'

/* TODO: review generated schema */
export class ListBaseFretebasSchema extends Schema {
  readonly name = 'ListBaseFretebas'

  readonly fieldSet: FieldSet<BaseFretebas> = {
    idFretebasPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    carga: (): FieldComponent => ({
      is: Component.Render,
    }),
    preco: (): FieldComponent => ({
      is: Component.Render,
    }),
    veiculos: (): FieldComponent => ({
      is: Component.Render,
    }),
    carroceria: (): FieldComponent => ({
      is: Component.Render,
    }),
    km: (): FieldComponent => ({
      is: Component.Render,
    }),
    especie: (): FieldComponent => ({
      is: Component.Render,
    }),
    complemento: (): FieldComponent => ({
      is: Component.Render,
    }),
    rastreamento: (): FieldComponent => ({
      is: Component.Render,
    }),
    obs: (): FieldComponent => ({
      is: Component.Render,
    }),
    nextel: (): FieldComponent => ({
      is: Component.Render,
    }),
    celular: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.celular),
      },
    }),
    fone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.fone),
      },
    }),
    whatsup: (): FieldComponent => ({
      is: Component.Render,
    }),
    sac: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    origem: (): FieldComponent => ({
      is: Component.Render,
    }),
    destino: (): FieldComponent => ({
      is: Component.Render,
    }),
    response: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
